var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 6H5.00001C4.46957 6 3.96086 6.21071 3.58579 6.58579C3.21072 6.96086 3.00001 7.46957 3.00001 8V28C2.9977 28.3814 3.10559 28.7553 3.31071 29.0768C3.51582 29.3984 3.80944 29.6538 4.15626 29.8125C4.42054 29.9356 4.70847 29.9995 5.00001 30C5.46951 29.9989 5.92344 29.8315 6.28126 29.5275L6.29251 29.5187L10.375 26H27C27.5304 26 28.0391 25.7893 28.4142 25.4142C28.7893 25.0391 29 24.5304 29 24V8C29 7.46957 28.7893 6.96086 28.4142 6.58579C28.0391 6.21071 27.5304 6 27 6ZM27 24H10C9.75989 24.0001 9.52784 24.0866 9.34626 24.2437L5.00001 28V8H27V24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.449bdc43cab25b9170b6e1d7bcb9dc0d.svg";
export { ForwardRef as ReactComponent };